/* eslint-disable
  no-param-reassign,
  no-underscore-dangle,
  no-console,
*/
import COA from '../class/coa';

export default {
  install(Vue, options = {}) {
    /** @memberof Vue.prototype */
    const coa = new COA(options);
    Vue.prototype.$coa = coa;
  },
};
